import React, { useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ASSETS_URL, store } from "../../../Store";

import { DropdownCuentaIndividual } from "./DropdownCuentaIndividual";
import { useIndividualHeaderDropdown } from "../../../../hooks/header/useIndividualHeaderDropdown";

/**
 * Componente con las opciones del header individual.
 *
 * @param {object} props
 * @param {object} props.textosInterfaz
 * @returns {JSX.Element}
 */
export const NavbarNav = ({ textosInterfaz }) => {

    const globalState = useContext(store);
    const { state } = globalState;

    const isLogged = state.sesionActiva === "SI";

    const dropdownButtonRef = useRef(null);
    const location = useLocation();

    const dropdown = useIndividualHeaderDropdown();
    const visible = dropdown?.state?.visible;

    const isActive =
        location.pathname.includes("/mi-panel") ||
        location.pathname === "/favoritos";

    useEffect(() => {
        if (dropdownButtonRef.current) {
            globalState.dispatch({
                type: "CHANGE",
                path: "individualHeaderDropdown.triggerButtonRef",
                value: dropdownButtonRef,
            });
        }
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 1 && window.scrollY < 10) {
                dropdown.setVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <ul className="option-nav d-flex justify-content-end align-items-center">
            <li className="relative h-100">
                <button
                    ref={dropdownButtonRef}
                    onClick={() => dropdown.setVisible(!visible)}
                    className={`d-flex justify-content-center align-items-center focusable-red
                            ${visible ? "openMode" : ""}
                            ${isActive ? "btn-header-general activeMode" : "btn-header-general"}
                        `}
                    aria-label={
                        textosInterfaz?.button_account_description ||
                        "Abrir la lista desplegable de páginas pertenecientes a mi cuenta"
                    }
                >
                    <div
                        className="mr-1 mr-lg-3 btn-avatar"
                        style={{
                            backgroundImage: `url('${isLogged
                                    ? `${ASSETS_URL}${state.datosHeader?.avatar}`
                                    : "/img/profile.png"
                                }')`,
                        }}
                    />

                    <span>
                        {textosInterfaz?.mi_cuenta || "Mi cuenta"}
                    </span>

                    <i
                        className="fas fa-chevron-down fa-sm ml-2 arrow"
                        aria-hidden="true"
                    />
                </button>

                <DropdownCuentaIndividual textosInterfaz={textosInterfaz} />
            </li>
        </ul>
    );
};